// extracted by mini-css-extract-plugin
module.exports = {"root":"ProductFeatures_root__5ugER","feature":"ProductFeatures_feature__q2ewj","image":"ProductFeatures_image__maXRR"};